/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Customer_Invite_AutomaticInputs */



/**
* | output |
* | --- |
* | "The administrator is emailed an invitation automatically when the term begins on {date}. Once it has, you can resend it from here until they sign up." |
*
* @param {Partner_Customer_Invite_AutomaticInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_invite_automatic = /** @type {((inputs: Partner_Customer_Invite_AutomaticInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Invite_AutomaticInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Administratorin oder der Administrator erhält zum Laufzeitbeginn am ${i?.date} automatisch eine Einladung per E-Mail. Danach können Sie sie hier erneut senden, bis die Registrierung abgeschlossen ist.`)
	return /** @type {LocalizedString} */ (`The administrator is emailed an invitation automatically when the term begins on ${i?.date}. Once it has, you can resend it from here until they sign up.`)
});